import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Text,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { endpointsList } from "../EndpointsList/endpointsList";
import RequestTypeText from "../RequestTypeText";

const ApiBlockNavigation = () => {
  return (
    <Accordion defaultIndex={[0, 1]} allowMultiple width="25%">
      <AccordionItem>
        <h2>
          <AccordionButton>
            <Box as="span" flex="1" textAlign="left">
              Getting started
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4}>
          <Link to="/api-docs/getting-started">Authentication</Link>
        </AccordionPanel>
      </AccordionItem>

      <AccordionItem>
        <h2>
          <AccordionButton>
            <Box as="span" flex="1" textAlign="left">
              Endpoints
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        {endpointsList.map((endpoint) => (
          <AccordionPanel pb={2} key={endpoint.name}>
            <Link to={endpoint.path}>
              <Flex alignItems="center">
                <RequestTypeText type={endpoint.type} />
                <Text ml={2}>{endpoint.name}</Text>
              </Flex>
            </Link>
          </AccordionPanel>
        ))}
      </AccordionItem>
    </Accordion>
  );
};

export default ApiBlockNavigation;
